// extracted by mini-css-extract-plugin
export default {"information":"DocumentInformation_information--l0P"};